module.exports = __webpack_public_path__ + "img/generated-1772421306899.c266389e.png";